import BaseRepository from './base.repository';

class TrackerRepository extends BaseRepository {
  constructor() {
    super('/trackers');
  }

  findTrendCards(condition) {
    return this.client.get('/patients/symptoms-trend-card', condition);
  }

  findHPSCard() {
    return this.client.get('/patients/health-progress-score-card');
  }

  findCopingTipCards() {
    return this.client.get('/patients/coping-tips-card');
  }

  findExpectedSymptomCards() {
    return this.client.get('/patients/expected-symptom-card');
  }

  triedCopingTip(symptomMainUnique, copingTipCode, payload) {
    return this.client.post(`/symptoms/${symptomMainUnique}/coping-tips/${copingTipCode}`, payload);
  }

  findAllSymptom() {
    return this.client.get('/symptoms');
  }

  findSymptomById(symptomMainUnique) {
    return this.client.get(`/symptoms/${symptomMainUnique}`);
  }

  recordSymptom(symptomMainUnique, payload) {
    return this.client.post(`/symptoms/${symptomMainUnique}/submit`, payload);
  }

  findAllExpectedSymptoms() {
    return this.client.get('/symptoms/expected');
  }

  remindRecordTomorrow(symptomMainUnique) {
    return this.client.post(`/symptoms/${symptomMainUnique}/remind-me-tomorrow`);
  }

  messageToCareTeam(payload) {
    return this.client.post('/patients/alert-care-team', payload);
  }

  getReminder(conditions) {
    return this.client.get('/symptoms/reminders', conditions);
  }

  seenReminder() {
    return this.client.put(`/symptoms/reminders/seen`);
  }

  updateDuration(symptomMainUnique, payload) {
    return this.client.put(`/symptoms/${symptomMainUnique}/duration`, payload);
  }

  findTriageTips(symptomMainUnique) {
    return this.client.get(`/patients/symptoms/${symptomMainUnique}/coping-tips`);
  }
}

export default new TrackerRepository();
